<template>
  <modal
    :visible="value"
    class="fast-payment-system-modal"
    @on-close="$emit('input', false)"
  >
    <vue-client-only>
      <m-fast-payment-system
        v-if="adaptive.isMobile"
        :data="data"
      />
      <d-fast-payment-system
        v-else
        :data="data"
      />
    </vue-client-only>
  </modal>
</template>

<script>
import VueClientOnly from 'vue-client-only';
import DFastPaymentSystem from './d-fast-payment-system.vue';
import MFastPaymentSystem from './m-fast-payment-system.vue';

export default {
  name: 'fast-payment-system-modal',

  components: {
    VueClientOnly,
    DFastPaymentSystem,
    MFastPaymentSystem,
  },

  inject: ['adaptive'],

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: null,
    }
  },
};
</script>

<style lang="scss">
.fast-payment-system-modal {
  & > .modal-content {
    height: 100%;
    max-height: none;
    border-radius: 0;
    padding: 14px 0 0;
  }
}

@include breakpoint("tablet") {
  .fast-payment-system-modal {
    & > .modal-content {
      width: 640px;
      height: auto;
      border-radius: 4px;
      padding: 16px 32px 24px;
    }
  }
}
</style>
